module.exports = __webpack_public_path__ + "img/auth-v1.dc3dd922.svg";